import { getLocalDb } from '../client'
import { STORES } from '../constants'

const toInt = (v) => {
  if (v == null || v === '') {
    return null
  }
  const n = Number(v)
  return Number.isFinite(n) ? Math.trunc(n) : null
}

/** Replace-all: snapshot penuh dari /pos/priceRules (tak ada delta). */
export const replacePriceRules = async (list) => {
  const db = await getLocalDb()
  const tx = db.transaction(STORES.PRICE_RULES, 'readwrite')
  await tx.store.clear()
  ;(Array.isArray(list) ? list : []).forEach((raw) => {
    const id = toInt(raw?.id)
    if (id != null) {
      tx.store.put({ ...raw, id })
    }
  })
  await tx.done
}

export const getPriceRules = async () => {
  const db = await getLocalDb()
  return db.getAll(STORES.PRICE_RULES)
}
